import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { IfTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-trade-store.directive';
import { LocalStore } from '../../../../model/store/store.decorator';
@Component({
    selector: 'store-open-status',
    templateUrl: './store-open-status.html',
    styleUrls: ['./store-open-status.scss'],
    standalone: true,
    imports: [IfTradeStoreDirective, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreOpenStatusComponent {
    @Input({
        required: true
    })
    store!: LocalStore;
}
